import IFormModel from "@/models/IFormModel";
import {FrameAssemblyInstallation, FrameAssemblyMeasuringPoint, FrameAssemblyType} from "@/helpers/constants";
import {ValidationRule} from "@/declarations/ValidationRule";
import FrameAssemblyRules from "@/models/frame-assembly/FrameAssemblyRules";

export default class FrameAssemblyCreate implements IFormModel {

	public frameType: FrameAssemblyType = FrameAssemblyType.frame;
	public width: number = 1000;
	public height: number = 1000;
	public measuringPoint: FrameAssemblyMeasuringPoint = FrameAssemblyMeasuringPoint.rebate;
	public installation: FrameAssemblyInstallation = FrameAssemblyInstallation.frame;
	public positionNr: string | null = null;
	public customerReference: string | null = null;
	public quantity: number = 1;

	reset(): void {
		this.customerReference = null;
		this.positionNr = null;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	rules(property: string): ValidationRule[] {
		switch (property){
			case 'width':
				if (this.frameType === FrameAssemblyType.corner) return FrameAssemblyRules.cornerWidthRules;
				return FrameAssemblyRules.widthRules;
			case 'height':
				if (this.frameType === FrameAssemblyType.corner) return FrameAssemblyRules.cornerHeightRules;
				return FrameAssemblyRules.heightRules;
			default:
				return [];
		}
	}

}
